import { render, staticRenderFns } from "./PaymentPayPal.vue?vue&type=template&id=04840471&"
import script from "./PaymentPayPal.vue?vue&type=script&lang=ts&"
export * from "./PaymentPayPal.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentPayPal.vue?vue&type=style&index=0&id=04840471&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports